/* 🤖 this file was generated by svg-to-ts */
export const matIconSquareFoot: {
  name: 'square-foot';
  data: string;
} = {
  name: 'square-foot',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17.66 17.66-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"/></svg>`
};
